<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="text-left panel-title" :class="isRemovedSubsection() ? 'comment-disabled' : ''">
        {{ title }}
        <a class="btn btn-sm" @click="$parent.$emit('onRemoveSection', stepName, subsection)">
          <span class="glyphicon" :class="isRemovedSubsection() ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
        </a>
      </h3>
    </div>
    <div class="panel-body subsection-content clearfix" :class="{ 'text-muted': isRemovedSubsection() }">
      <div class="subsection-filter" :class="{ active: isRemovedSubsection() }"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subsection',
  props: ['title', 'stepName', 'subsection'],
  methods: {
    isRemovedSubsection: function () {
      return this.$parent.isRemovedSubsection(this.subsection)
    },
  },
}
</script>
<style>
.subsection-content {
  position: relative;
}
.subsection-filter {
  position: absolute;
}
.subsection-filter.active {
  background: rgb(245 245 245 / 43%);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
